import express, { Router } from 'express';

import * as leadScoreValidation from './leadScore.validation';
import * as leadScoreController from './leadScore.controller';

import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { AuditMode } from '@/shared/constants/enum.constant';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import validate from '@/shared/utils/middlewares/validate.middleware';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.LEAD_SCORE, ACTIONS.READ),
    validate(leadScoreValidation.getLeadScoreConfig),
    leadScoreController.getLeadScoreConfigs,
  )
  .post(
    userAuthAndCheckPermissions(),
    validate(leadScoreValidation.createLeadScoreConfig),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    leadScoreController.createLeadScoreConfig,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(),
    validate(leadScoreValidation.getLeadScoreConfigById),
    leadScoreController.getLeadScoreConfigById,
  )
  .patch(
    userAuthAndCheckPermissions(),
    validate(leadScoreValidation.updateLeadScoreConfig()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    leadScoreController.updateLeadScoreConfig,
  )
  .delete(
    userAuthAndCheckPermissions(),
    validate(leadScoreValidation.deleteLeadScoreConfigById),
    leadScoreController.deleteLeadScoreConfig,
  );

export default router;
